import { format, parseISO } from "date-fns";
import { id as localeId } from "date-fns/locale";

export const rupiah = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);

export const iso = (d) => format(d, "yyyy-MM-dd");
export const todayIso = () => iso(new Date());
export const monthKey = (d = new Date()) => format(d, "yyyy-MM");
export const fmtDate = (s, f = "d MMM yyyy") => (s ? format(parseISO(s), f, { locale: localeId }) : "-");
export const fmtMonth = (d) => format(d, "MMMM yyyy", { locale: localeId });
export const sum = (arr, key = "amount") => arr.reduce((a, b) => a + Number(b[key] || 0), 0);

export const INCOME_TYPES = { salary: "Gajiku", commission: "Komisiku", tips: "Tipsku", other: "Lainnya" };
export const EXPENSE_CATS = ["Makan", "Transport", "Belanja", "Tagihan", "Hiburan", "Kesehatan", "Skincare", "Lainnya"];
